export default __webpack_public_path__ + "static/1859-c8e8882c73b9431025a054de73ea653a.gif";